
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  QCTaskState,
  QCTaskFetchAction,
  QCTaskFetchSuccessAction,
  QCTaskAssignAction,
  QCTaskChangeStatusAction,
} from './QCTask.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const initialState: QCTaskState = {
  loading: false,
  error: undefined,
  data: null,
  assignLoading: false,
  changeStatusLoading: false,
  DICOMResource: null,
};

const { actReq, actResolve, actReject, act } = makeActionCreator<QCTaskState>();

export const QCTaskSlice = createSlice({
  name: 'QCTask',
  initialState,
  reducers: {
    fetchQCTask: actReq<QCTaskFetchAction['payload']>(),
    fetchQCTaskSuccess: act<QCTaskFetchSuccessAction['payload']>(
      ({ task, DICOMResource }) => ({
        data: task,
        loading: false,
        DICOMResource,
      })
    ),
    fetchQCTaskFailure: act(() => ({
      loading: false,
      error: true,
    })),

    assign: actReq<QCTaskAssignAction['payload']>('assignLoading'),
    assignSuccess: actResolve<boolean>(null, 'assignLoading'),
    assignFailure: actReject('error', 'assignLoading'),
    changeStatus: actReq<QCTaskChangeStatusAction['payload']>(
      'changeStatusLoading'
    ),
    changeStatusSuccess: (
      state,
      action: PayloadAction<QCTaskChangeStatusAction['payload']['status']>
    ) => {
      if (state.data) {
        state.data.status = action.payload;
        state.changeStatusLoading = false;
      }
    },
    changeStatusFailure: actReject('error', 'changeStatusLoading'),
    clear: state => {
      state.data = null;
    },
  },
});

export const {
  fetchQCTask,
  fetchQCTaskSuccess,
  fetchQCTaskFailure,
  assign,
  assignSuccess,
  assignFailure,
  changeStatus,
  changeStatusSuccess,
  changeStatusFailure,

  clear,
} = QCTaskSlice.actions;

export const actions = {
  ...QCTaskSlice.actions,
};

export const useQCTaskSlice = createSliceHook(QCTaskSlice.name, actions);

export const selectQCTaskState = createSelector('QCTask');
